import { render, staticRenderFns } from "./add-new-primary-role-access-popup.vue?vue&type=template&id=2eb63f56&"
import script from "./add-new-primary-role-access-popup.vue?vue&type=script&lang=ts&"
export * from "./add-new-primary-role-access-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports